document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest('button[data-cp-filter]');
  const finder = button?.closest('[data-cp-collection-finder]');
  const component = finder?.closest('collection-component');
  const results = component?.querySelector('#ResultsList');
  if (!button || !finder || !component || !results) return;

  const cards = [...results.querySelectorAll('li.product-grid__item[data-cp-kind]')];
  const kind = button.dataset.cpFilter;
  let visible = 0;

  for (const card of cards) {
    const matches = kind === 'all' || card.dataset.cpKind === kind;
    card.hidden = !matches;
    if (matches) visible += 1;
  }

  for (const option of finder.querySelectorAll('button[data-cp-filter]')) {
    option.setAttribute('aria-pressed', String(option === button));
  }

  const status = finder.querySelector('[role="status"]');
  if (status) {
    status.textContent = (finder.dataset.countTemplate || '')
      .replaceAll('__visible__', String(visible))
      .replaceAll('__total__', String(cards.length));
  }
});

